module.exports = new __parcel__URL__("troops_ars_v2.d12d1b26.png").toString();